module.exports = __webpack_public_path__ + "img/banner_hk.065242e4.jpg";